"use client";

import { c as _c } from "react/compiler-runtime";
import type { ArticleSection } from "@modules/article/lib/getArticle";
import type { EmbedKind } from "@modules/article/lib/toArticleView";
import type { Resource } from "i18next";
import dynamic from "next/dynamic";
import { Suspense } from "react";
import LegacyEmbedBridge from "../LegacyEmbedBridge";
const MonthlyPaymentCalculator = dynamic(() => import("@modules/learning-center/components/ArticleTools").then(module => module.ArticleMonthlyPaymentCalculator), {
  ssr: false
});
const SpecialRepaymentComparison = dynamic(() => import("@modules/learning-center/components/ArticleTools").then(module => module.ArticleSpecialRepaymentComparison), {
  ssr: false
});
const BorrowingCapacityCalculator = dynamic(() => import("@modules/learning-center/components/ArticleTools").then(module => module.ArticleBorrowingCapacityCalculator), {
  ssr: false
});
const BudgetCalculator = dynamic(() => import("@components/BudgetCalculator"), {
  ssr: false
});
const EmbeddedBudgetCheck = dynamic(() => import("@modules/homepage/components/EmbeddedBudgetCheck"), {
  ssr: false
});
const Heyflow = dynamic(() => import("@modules/homepage/sections/Heyflow"), {
  ssr: false
});
const HubspotForm = dynamic(() => import("@modules/homepage/sections/HubspotForm"), {
  ssr: false
});
const MediaOutlets = dynamic(() => import("@components/blocks/MediaOutlets"), {
  ssr: false
});
const Embed = t0 => {
  const $ = _c(14);
  const {
    embed,
    section
  } = t0;
  const data = section as never;
  switch (embed) {
    case "sections.article-monthly-payment-calculator":
      {
        let t1;
        if ($[0] !== data) {
          t1 = <MonthlyPaymentCalculator data={data} />;
          $[0] = data;
          $[1] = t1;
        } else {
          t1 = $[1];
        }
        return t1;
      }
    case "sections.article-special-repayment-comparison":
      {
        let t1;
        if ($[2] !== data) {
          t1 = <SpecialRepaymentComparison data={data} />;
          $[2] = data;
          $[3] = t1;
        } else {
          t1 = $[3];
        }
        return t1;
      }
    case "sections.article-borrowing-capacity-calculator":
      {
        let t1;
        if ($[4] !== data) {
          t1 = <BorrowingCapacityCalculator data={data} />;
          $[4] = data;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case "sections.budget-calculator":
      {
        let t1;
        if ($[6] !== data) {
          t1 = <BudgetCalculator data={data} />;
          $[6] = data;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    case "sections.budget-check-form":
      {
        let t1;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <EmbeddedBudgetCheck />;
          $[8] = t1;
        } else {
          t1 = $[8];
        }
        return t1;
      }
    case "sections.heyflow":
      {
        let t1;
        if ($[9] !== data) {
          t1 = <Heyflow data={data} index={0} />;
          $[9] = data;
          $[10] = t1;
        } else {
          t1 = $[10];
        }
        return t1;
      }
    case "sections.hubspot-form":
      {
        let t1;
        if ($[11] !== data) {
          t1 = <HubspotForm data={data} index={0} />;
          $[11] = data;
          $[12] = t1;
        } else {
          t1 = $[12];
        }
        return t1;
      }
    case "sections.media-outlets":
      {
        let t1;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <MediaOutlets />;
          $[13] = t1;
        } else {
          t1 = $[13];
        }
        return t1;
      }
  }
};
const ArticleEmbed = t0 => {
  const $ = _c(7);
  const {
    embed,
    section,
    language,
    resources
  } = t0;
  let t1;
  if ($[0] !== embed || $[1] !== section) {
    t1 = <Embed embed={embed} section={section} />;
    $[0] = embed;
    $[1] = section;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== language || $[4] !== resources || $[5] !== t1) {
    t2 = <div className="bg-neutral-12 rounded-m p-s m:p-m [&>*]:!m-none [&>section]:!border-none [&>section]:!shadow-none [&>section]:!bg-transparent [&>section]:!p-none"><Suspense><LegacyEmbedBridge language={language} resources={resources}>{t1}</LegacyEmbedBridge></Suspense></div>;
    $[3] = language;
    $[4] = resources;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default ArticleEmbed;